// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  /* Box sizing reset */
  *,
  *::before,
  *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    border-width: 0; /* Explicitly reset border width */
    border-style: solid; /* Ensure consistent border style */
  }

  /* Basic document-level defaults */
  html {
    line-height: 1.5;
    -webkit-text-size-adjust: 100%;
    font-family: inherit;
  }

  body {
    min-height: 100vh;
    scroll-behavior: smooth;
    text-rendering: optimizeSpeed;
  }

  /* Make images easier to work with */
  img,
  picture {
    max-width: 100%;
    display: block;
  }

  /* Inherit fonts for inputs and buttons */
  input,
  button,
  textarea,
  select {
    font: inherit;
    /* border: inherit;  */
    border-color: inherit;
    background-color: inherit;
  }

  /* Remove list styles */
  ul,
  ol {
    list-style: none;
  }

  /* Anchor tag reset */
  a {
    text-decoration: inherit;
    color: inherit;
  }

  /* Only lighten existing div borders */
  div,
  input,
  textarea {
    border-color: inherit; /* Prevent forcing borders on all divs */
  }
*, ::before, ::after {
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x:  ;
    --tw-pan-y:  ;
    --tw-pinch-zoom:  ;
    --tw-scroll-snap-strictness: proximity;
    --tw-gradient-from-position:  ;
    --tw-gradient-via-position:  ;
    --tw-gradient-to-position:  ;
    --tw-ordinal:  ;
    --tw-slashed-zero:  ;
    --tw-numeric-figure:  ;
    --tw-numeric-spacing:  ;
    --tw-numeric-fraction:  ;
    --tw-ring-inset:  ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgb(59 130 246 / 0.5);
    --tw-ring-offset-shadow: 0 0 #0000;
    --tw-ring-shadow: 0 0 #0000;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    --tw-blur:  ;
    --tw-brightness:  ;
    --tw-contrast:  ;
    --tw-grayscale:  ;
    --tw-hue-rotate:  ;
    --tw-invert:  ;
    --tw-saturate:  ;
    --tw-sepia:  ;
    --tw-drop-shadow:  ;
    --tw-backdrop-blur:  ;
    --tw-backdrop-brightness:  ;
    --tw-backdrop-contrast:  ;
    --tw-backdrop-grayscale:  ;
    --tw-backdrop-hue-rotate:  ;
    --tw-backdrop-invert:  ;
    --tw-backdrop-opacity:  ;
    --tw-backdrop-saturate:  ;
    --tw-backdrop-sepia:  ;
}
::backdrop {
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x:  ;
    --tw-pan-y:  ;
    --tw-pinch-zoom:  ;
    --tw-scroll-snap-strictness: proximity;
    --tw-gradient-from-position:  ;
    --tw-gradient-via-position:  ;
    --tw-gradient-to-position:  ;
    --tw-ordinal:  ;
    --tw-slashed-zero:  ;
    --tw-numeric-figure:  ;
    --tw-numeric-spacing:  ;
    --tw-numeric-fraction:  ;
    --tw-ring-inset:  ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgb(59 130 246 / 0.5);
    --tw-ring-offset-shadow: 0 0 #0000;
    --tw-ring-shadow: 0 0 #0000;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    --tw-blur:  ;
    --tw-brightness:  ;
    --tw-contrast:  ;
    --tw-grayscale:  ;
    --tw-hue-rotate:  ;
    --tw-invert:  ;
    --tw-saturate:  ;
    --tw-sepia:  ;
    --tw-drop-shadow:  ;
    --tw-backdrop-blur:  ;
    --tw-backdrop-brightness:  ;
    --tw-backdrop-contrast:  ;
    --tw-backdrop-grayscale:  ;
    --tw-backdrop-hue-rotate:  ;
    --tw-backdrop-invert:  ;
    --tw-backdrop-opacity:  ;
    --tw-backdrop-saturate:  ;
    --tw-backdrop-sepia:  ;
}
.\\!container {
    width: 100% !important;
}
.container {
    width: 100%;
}
@media (min-width: 640px) {
    .\\!container {
        max-width: 640px !important;
    }
    .container {
        max-width: 640px;
    }
}
@media (min-width: 768px) {
    .\\!container {
        max-width: 768px !important;
    }
    .container {
        max-width: 768px;
    }
}
@media (min-width: 1024px) {
    .\\!container {
        max-width: 1024px !important;
    }
    .container {
        max-width: 1024px;
    }
}
@media (min-width: 1280px) {
    .\\!container {
        max-width: 1280px !important;
    }
    .container {
        max-width: 1280px;
    }
}
@media (min-width: 1536px) {
    .\\!container {
        max-width: 1536px !important;
    }
    .container {
        max-width: 1536px;
    }
}
.pointer-events-none {
    pointer-events: none;
}
.visible {
    visibility: visible;
}
.fixed {
    position: fixed;
}
.absolute {
    position: absolute;
}
.relative {
    position: relative;
}
.sticky {
    position: sticky;
}
.inset-0 {
    inset: 0px;
}
.inset-y-0 {
    top: 0px;
    bottom: 0px;
}
.-top-4 {
    top: -1rem;
}
.bottom-0 {
    bottom: 0px;
}
.bottom-full {
    bottom: 100%;
}
.left-0 {
    left: 0px;
}
.left-2 {
    left: 0.5rem;
}
.left-full {
    left: 100%;
}
.right-0 {
    right: 0px;
}
.right-2 {
    right: 0.5rem;
}
.right-full {
    right: 100%;
}
.top-0 {
    top: 0px;
}
.top-1\\/2 {
    top: 50%;
}
.top-2 {
    top: 0.5rem;
}
.top-6 {
    top: 1.5rem;
}
.top-full {
    top: 100%;
}
.z-10 {
    z-index: 10;
}
.z-100000 {
    z-index: 100000;
}
.z-100002 {
    z-index: 100002;
}
.z-100050 {
    z-index: 100050;
}
.z-100051 {
    z-index: 100051;
}
.z-50 {
    z-index: 50;
}
.m-2 {
    margin: 0.5rem;
}
.m-\\[50px\\] {
    margin: 50px;
}
.my-2 {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
}
.-mt-px {
    margin-top: -1px;
}
.mb-1 {
    margin-bottom: 0.25rem;
}
.mb-2 {
    margin-bottom: 0.5rem;
}
.mb-4 {
    margin-bottom: 1rem;
}
.mb-6 {
    margin-bottom: 1.5rem;
}
.ml-1 {
    margin-left: 0.25rem;
}
.ml-2 {
    margin-left: 0.5rem;
}
.ml-5 {
    margin-left: 1.25rem;
}
.ml-6 {
    margin-left: 1.5rem;
}
.ml-auto {
    margin-left: auto;
}
.mr-1 {
    margin-right: 0.25rem;
}
.mr-2 {
    margin-right: 0.5rem;
}
.mr-4 {
    margin-right: 1rem;
}
.mt-1 {
    margin-top: 0.25rem;
}
.mt-2 {
    margin-top: 0.5rem;
}
.mt-4 {
    margin-top: 1rem;
}
.mt-5 {
    margin-top: 1.25rem;
}
.mt-6 {
    margin-top: 1.5rem;
}
.block {
    display: block;
}
.inline-block {
    display: inline-block;
}
.flex {
    display: flex;
}
.inline-flex {
    display: inline-flex;
}
.grid {
    display: grid;
}
.hidden {
    display: none;
}
.size-4 {
    width: 1rem;
    height: 1rem;
}
.size-5 {
    width: 1.25rem;
    height: 1.25rem;
}
.size-6 {
    width: 1.5rem;
    height: 1.5rem;
}
.size-8 {
    width: 2rem;
    height: 2rem;
}
.\\!h-4 {
    height: 1rem !important;
}
.\\!h-full {
    height: 100% !important;
}
.h-0 {
    height: 0px;
}
.h-10 {
    height: 2.5rem;
}
.h-12 {
    height: 3rem;
}
.h-16 {
    height: 4rem;
}
.h-2 {
    height: 0.5rem;
}
.h-3 {
    height: 0.75rem;
}
.h-4 {
    height: 1rem;
}
.h-48 {
    height: 12rem;
}
.h-5 {
    height: 1.25rem;
}
.h-6 {
    height: 1.5rem;
}
.h-8 {
    height: 2rem;
}
.h-\\[700px\\] {
    height: 700px;
}
.h-auto {
    height: auto;
}
.h-dvh {
    height: 100dvh;
}
.h-full {
    height: 100%;
}
.max-h-60 {
    max-height: 15rem;
}
.max-h-72 {
    max-height: 18rem;
}
.max-h-\\[90vh\\] {
    max-height: 90vh;
}
.max-h-full {
    max-height: 100%;
}
.min-h-10 {
    min-height: 2.5rem;
}
.min-h-\\[150px\\] {
    min-height: 150px;
}
.min-h-\\[300px\\] {
    min-height: 300px;
}
.min-h-\\[600px\\] {
    min-height: 600px;
}
.\\!w-4 {
    width: 1rem !important;
}
.\\!w-full {
    width: 100% !important;
}
.w-0 {
    width: 0px;
}
.w-0\\.5 {
    width: 0.125rem;
}
.w-10 {
    width: 2.5rem;
}
.w-12 {
    width: 3rem;
}
.w-16 {
    width: 4rem;
}
.w-2 {
    width: 0.5rem;
}
.w-2\\/6 {
    width: 33.333333%;
}
.w-20 {
    width: 5rem;
}
.w-24 {
    width: 6rem;
}
.w-3 {
    width: 0.75rem;
}
.w-3\\/6 {
    width: 50%;
}
.w-32 {
    width: 8rem;
}
.w-4 {
    width: 1rem;
}
.w-4\\/6 {
    width: 66.666667%;
}
.w-40 {
    width: 10rem;
}
.w-5 {
    width: 1.25rem;
}
.w-5\\/6 {
    width: 83.333333%;
}
.w-6 {
    width: 1.5rem;
}
.w-64 {
    width: 16rem;
}
.w-8 {
    width: 2rem;
}
.w-\\[1200px\\] {
    width: 1200px;
}
.w-\\[300px\\] {
    width: 300px;
}
.w-full {
    width: 100%;
}
.min-w-\\[140px\\] {
    min-width: 140px;
}
.max-w-2xl {
    max-width: 42rem;
}
.max-w-\\[350px\\] {
    max-width: 350px;
}
.max-w-full {
    max-width: 100%;
}
.max-w-lg {
    max-width: 32rem;
}
.max-w-md {
    max-width: 28rem;
}
.max-w-sm {
    max-width: 24rem;
}
.max-w-xl {
    max-width: 36rem;
}
.max-w-xs {
    max-width: 20rem;
}
.flex-1 {
    flex: 1 1 0%;
}
.flex-shrink-0 {
    flex-shrink: 0;
}
.flex-grow {
    flex-grow: 1;
}
.grow {
    flex-grow: 1;
}
.border-collapse {
    border-collapse: collapse;
}
.-translate-x-1 {
    --tw-translate-x: -0.25rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-1\\/2 {
    --tw-translate-x: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1 {
    --tw-translate-y: -0.25rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
    --tw-translate-y: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1 {
    --tw-translate-x: 0.25rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-1 {
    --tw-translate-y: 0.25rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-0 {
    --tw-rotate: 0deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
    --tw-rotate: 180deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45 {
    --tw-rotate: 45deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse {
    50% {
        opacity: .5;
    }
}
.animate-pulse {
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes slideInTop {
    0% {
        transform: translateY(100%);
    }
    100% {
        transform: translateY(0);
    }
}
.animate-slide-in-top {
    animation: slideInTop 0.3s ease-out;
}
@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}
.animate-spin {
    animation: spin 1s linear infinite;
}
.cursor-default {
    cursor: default;
}
.cursor-grab {
    cursor: grab;
}
.cursor-pointer {
    cursor: pointer;
}
.select-none {
    -webkit-user-select: none;
            user-select: none;
}
.list-inside {
    list-style-position: inside;
}
.list-decimal {
    list-style-type: decimal;
}
.grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
}
.flex-row {
    flex-direction: row;
}
.flex-col {
    flex-direction: column;
}
.flex-wrap {
    flex-wrap: wrap;
}
.items-start {
    align-items: flex-start;
}
.items-end {
    align-items: flex-end;
}
.items-center {
    align-items: center;
}
.justify-end {
    justify-content: flex-end;
}
.justify-center {
    justify-content: center;
}
.justify-between {
    justify-content: space-between;
}
.gap-0 {
    gap: 0px;
}
.gap-1 {
    gap: 0.25rem;
}
.gap-2 {
    gap: 0.5rem;
}
.gap-3 {
    gap: 0.75rem;
}
.gap-4 {
    gap: 1rem;
}
.gap-5 {
    gap: 1.25rem;
}
.gap-6 {
    gap: 1.5rem;
}
.gap-\\[10px\\] {
    gap: 10px;
}
.gap-\\[6px\\] {
    gap: 6px;
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.75rem * var(--tw-space-x-reverse));
    margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.overflow-auto {
    overflow: auto;
}
.overflow-hidden {
    overflow: hidden;
}
.overflow-visible {
    overflow: visible;
}
.overflow-x-auto {
    overflow-x: auto;
}
.overflow-y-auto {
    overflow-y: auto;
}
.truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.whitespace-nowrap {
    white-space: nowrap;
}
.whitespace-pre-wrap {
    white-space: pre-wrap;
}
.text-wrap {
    text-wrap: wrap;
}
.break-words {
    overflow-wrap: break-word;
}
.break-all {
    word-break: break-all;
}
.\\!rounded {
    border-radius: 0.25rem !important;
}
.\\!rounded-lg {
    border-radius: 0.5rem !important;
}
.\\!rounded-md {
    border-radius: 0.375rem !important;
}
.rounded {
    border-radius: 0.25rem;
}
.rounded-2xl {
    border-radius: 1rem;
}
.rounded-\\[10px\\] {
    border-radius: 10px;
}
.rounded-\\[20px\\] {
    border-radius: 20px;
}
.rounded-\\[30px\\] {
    border-radius: 30px;
}
.rounded-full {
    border-radius: 9999px;
}
.rounded-lg {
    border-radius: 0.5rem;
}
.rounded-md {
    border-radius: 0.375rem;
}
.rounded-none {
    border-radius: 0px;
}
.rounded-xl {
    border-radius: 0.75rem;
}
.rounded-e-md {
    border-start-end-radius: 0.375rem;
    border-end-end-radius: 0.375rem;
}
.rounded-l-md {
    border-top-left-radius: 0.375rem;
    border-bottom-left-radius: 0.375rem;
}
.rounded-r-md {
    border-top-right-radius: 0.375rem;
    border-bottom-right-radius: 0.375rem;
}
.rounded-s-md {
    border-start-start-radius: 0.375rem;
    border-end-start-radius: 0.375rem;
}
.rounded-t {
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
}
.\\!border {
    border-width: 1px !important;
}
.border {
    border-width: 1px;
}
.border-4 {
    border-width: 4px;
}
.border-cardBorderWidth {
    border-width: var(--card-borderWidth);
}
.border-columnBorderWidth {
    border-width: var(--column-borderWidth);
}
.border-b {
    border-bottom-width: 1px;
}
.border-b-0 {
    border-bottom-width: 0px;
}
.border-b-2 {
    border-bottom-width: 2px;
}
.border-b-4 {
    border-bottom-width: 4px;
}
.border-l {
    border-left-width: 1px;
}
.border-l-2 {
    border-left-width: 2px;
}
.border-r {
    border-right-width: 1px;
}
.border-t {
    border-top-width: 1px;
}
.border-solid {
    border-style: solid;
}
.\\!border-none {
    border-style: none !important;
}
.\\!border-gray-300 {
    --tw-border-opacity: 1 !important;
    border-color: rgb(209 213 219 / var(--tw-border-opacity)) !important;
}
.\\!border-vjwDanger {
    --tw-border-opacity: 1 !important;
    border-color: hsl(from var(--color-danger) h s l / var(--tw-border-opacity)) !important;
}
.border-\\[\\#EEEEEE\\] {
    --tw-border-opacity: 1;
    border-color: rgb(238 238 238 / var(--tw-border-opacity));
}
.border-blue-500 {
    --tw-border-opacity: 1;
    border-color: rgb(59 130 246 / var(--tw-border-opacity));
}
.border-cardBorderColor {
    border-color: var(--card-borderColor);
}
.border-columnBorderColor {
    border-color: var(--column-borderColor);
}
.border-gray-200 {
    --tw-border-opacity: 1;
    border-color: rgb(229 231 235 / var(--tw-border-opacity));
}
.border-gray-300 {
    --tw-border-opacity: 1;
    border-color: rgb(209 213 219 / var(--tw-border-opacity));
}
.border-red-500 {
    --tw-border-opacity: 1;
    border-color: rgb(239 68 68 / var(--tw-border-opacity));
}
.border-transparent {
    border-color: transparent;
}
.border-vjwDanger {
    --tw-border-opacity: 1;
    border-color: hsl(from var(--color-danger) h s l / var(--tw-border-opacity));
}
.border-vjwPrimary {
    --tw-border-opacity: 1;
    border-color: hsl(from var(--color-primary) h s l / var(--tw-border-opacity));
}
.border-vjwSecondary {
    --tw-border-opacity: 1;
    border-color: hsl(from var(--color-secondary) h s l / var(--tw-border-opacity));
}
.border-b-vjwPrimary {
    --tw-border-opacity: 1;
    border-bottom-color: hsl(from var(--color-primary) h s l / var(--tw-border-opacity));
}
.border-t-transparent {
    border-top-color: transparent;
}
.bg-\\[\\#324ECF\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(50 78 207 / var(--tw-bg-opacity));
}
.bg-black {
    --tw-bg-opacity: 1;
    background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.bg-blue-100 {
    --tw-bg-opacity: 1;
    background-color: rgb(219 234 254 / var(--tw-bg-opacity));
}
.bg-blue-50 {
    --tw-bg-opacity: 1;
    background-color: rgb(239 246 255 / var(--tw-bg-opacity));
}
.bg-blue-600 {
    --tw-bg-opacity: 1;
    background-color: rgb(37 99 235 / var(--tw-bg-opacity));
}
.bg-cardBackground {
    background-color: var(--card-backgroundColor);
}
.bg-columnBackground {
    background-color: var(--column-backgroundColor);
}
.bg-columnHeadingBackgroundColor {
    background-color: var(--column-heading-backgroundColor);
}
.bg-columnSubHeadingBackgroundColor {
    background-color: var(--column-subHeading-backgroundColor);
}
.bg-containerBackground {
    background-color: var(--color-background);
}
.bg-gray-100 {
    --tw-bg-opacity: 1;
    background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.bg-gray-200 {
    --tw-bg-opacity: 1;
    background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}
.bg-gray-300 {
    --tw-bg-opacity: 1;
    background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}
.bg-gray-50 {
    --tw-bg-opacity: 1;
    background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.bg-gray-800 {
    --tw-bg-opacity: 1;
    background-color: rgb(31 41 55 / var(--tw-bg-opacity));
}
.bg-indigo-100 {
    --tw-bg-opacity: 1;
    background-color: rgb(224 231 255 / var(--tw-bg-opacity));
}
.bg-indigo-600 {
    --tw-bg-opacity: 1;
    background-color: rgb(79 70 229 / var(--tw-bg-opacity));
}
.bg-transparent {
    background-color: transparent;
}
.bg-vjwDanger {
    --tw-bg-opacity: 1;
    background-color: hsl(from var(--color-danger) h s l / var(--tw-bg-opacity));
}
.bg-vjwDanger\\/20 {
    background-color: hsl(from var(--color-danger) h s l / 0.2);
}
.bg-vjwPrimary {
    --tw-bg-opacity: 1;
    background-color: hsl(from var(--color-primary) h s l / var(--tw-bg-opacity));
}
.bg-vjwPrimary\\/10 {
    background-color: hsl(from var(--color-primary) h s l / 0.1);
}
.bg-vjwPrimary\\/20 {
    background-color: hsl(from var(--color-primary) h s l / 0.2);
}
.bg-vjwSecondary {
    --tw-bg-opacity: 1;
    background-color: hsl(from var(--color-secondary) h s l / var(--tw-bg-opacity));
}
.bg-vjwSuccess {
    --tw-bg-opacity: 1;
    background-color: hsl(from var(--color-success) h s l / var(--tw-bg-opacity));
}
.bg-white {
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-opacity-50 {
    --tw-bg-opacity: 0.5;
}
.stroke-current {
    stroke: currentColor;
}
.object-cover {
    object-fit: cover;
}
.p-0 {
    padding: 0px;
}
.p-0\\.5 {
    padding: 0.125rem;
}
.p-1 {
    padding: 0.25rem;
}
.p-1\\.5 {
    padding: 0.375rem;
}
.p-2 {
    padding: 0.5rem;
}
.p-3 {
    padding: 0.75rem;
}
.p-4 {
    padding: 1rem;
}
.p-5 {
    padding: 1.25rem;
}
.p-6 {
    padding: 1.5rem;
}
.p-\\[10px\\] {
    padding: 10px;
}
.p-\\[14px\\] {
    padding: 14px;
}
.p-\\[30px\\] {
    padding: 30px;
}
.\\!px-2 {
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
}
.\\!px-4 {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
}
.\\!py-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
}
.\\!py-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
}
.px-0 {
    padding-left: 0px;
    padding-right: 0px;
}
.px-1 {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
}
.px-1\\.5 {
    padding-left: 0.375rem;
    padding-right: 0.375rem;
}
.px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
}
.px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
}
.px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
}
.px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
}
.px-\\[10px\\] {
    padding-left: 10px;
    padding-right: 10px;
}
.px-\\[20px\\] {
    padding-left: 20px;
    padding-right: 20px;
}
.py-0 {
    padding-top: 0px;
    padding-bottom: 0px;
}
.py-0\\.5 {
    padding-top: 0.125rem;
    padding-bottom: 0.125rem;
}
.py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
}
.py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}
.py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
}
.py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
}
.py-\\[6px\\] {
    padding-top: 6px;
    padding-bottom: 6px;
}
.\\!pr-20 {
    padding-right: 5rem !important;
}
.pb-10 {
    padding-bottom: 2.5rem;
}
.pb-4 {
    padding-bottom: 1rem;
}
.pb-\\[20px\\] {
    padding-bottom: 20px;
}
.pl-10 {
    padding-left: 2.5rem;
}
.pl-2 {
    padding-left: 0.5rem;
}
.pl-3 {
    padding-left: 0.75rem;
}
.pl-4 {
    padding-left: 1rem;
}
.pr-1 {
    padding-right: 0.25rem;
}
.pr-4 {
    padding-right: 1rem;
}
.pr-6 {
    padding-right: 1.5rem;
}
.\\!text-center {
    text-align: center !important;
}
.text-center {
    text-align: center;
}
.font-fontFamily {
    font-family: var(--fontFamily);
}
.text-\\[16px\\] {
    font-size: 16px;
}
.text-\\[22px\\] {
    font-size: 22px;
}
.text-\\[8px\\] {
    font-size: 8px;
}
.text-base {
    font-size: 1rem;
    line-height: 1.5rem;
}
.text-cardHeadingFontSize {
    font-size: var(--card-heading-fontSize);
}
.text-columnFontSize {
    font-size: var(--column-fontSize);
}
.text-columnHeadingFontSize {
    font-size: var(--column-heading-fontSize);
}
.text-columnSubHeadingFontSize {
    font-size: var(--column-subHeading-fontSize);
}
.text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
}
.text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
}
.text-typographyHeadingFontSize {
    font-size: var(--typography-heading-fontSize);
}
.text-typographyLabelsFontSize {
    font-size: var(--typography-labels-fontSize);
}
.text-typographySubheadingFontSize {
    font-size: var(--typography-subHeading-fontSize);
}
.text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
}
.text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
}
.font-bold {
    font-weight: 700;
}
.font-cardHeadingFontWeight {
    font-weight: var(--card-heading-fontWeight);
}
.font-columnFontWeight {
    font-weight: var(--column-fontWeight);
}
.font-columnHeadingFontWeight {
    font-weight: var(--column-heading-fontWeight);
}
.font-columnSubHeadingFontWeight {
    font-weight: var(--column-subHeading-fontWeight);
}
.font-medium {
    font-weight: 500;
}
.font-normal {
    font-weight: 400;
}
.font-semibold {
    font-weight: 600;
}
.font-typographyHeadingFontWeight {
    font-weight: var(--typography-heading-fontWeight);
}
.font-typographyLabelsFontWeight {
    font-weight: var(--typography-labels-fontWeight);
}
.font-typographySubheadingFontWeight {
    font-weight: var(--typography-subHeading-fontWeight);
}
.leading-none {
    line-height: 1;
}
.\\!text-gray-700 {
    --tw-text-opacity: 1 !important;
    color: rgb(55 65 81 / var(--tw-text-opacity)) !important;
}
.text-\\[\\#111A45\\] {
    --tw-text-opacity: 1;
    color: rgb(17 26 69 / var(--tw-text-opacity));
}
.text-\\[\\#8E95AA\\] {
    --tw-text-opacity: 1;
    color: rgb(142 149 170 / var(--tw-text-opacity));
}
.text-black {
    --tw-text-opacity: 1;
    color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-blue-500 {
    --tw-text-opacity: 1;
    color: rgb(59 130 246 / var(--tw-text-opacity));
}
.text-blue-600 {
    --tw-text-opacity: 1;
    color: rgb(37 99 235 / var(--tw-text-opacity));
}
.text-cardHeadingTextColor {
    color: var(--card-heading-color);
}
.text-cardSubHeadingTextColor {
    color: var(--card-subHeading-color);
}
.text-cardTextColor {
    color: var(--card-color);
}
.text-columnHeadingTextColor {
    color: var(--column-heading-color);
}
.text-columnSubHeadingTextColor {
    color: var(--column-subHeading-color);
}
.text-columnTextColor {
    color: var(--column-color);
}
.text-gray-200 {
    --tw-text-opacity: 1;
    color: rgb(229 231 235 / var(--tw-text-opacity));
}
.text-gray-400 {
    --tw-text-opacity: 1;
    color: rgb(156 163 175 / var(--tw-text-opacity));
}
.text-gray-500 {
    --tw-text-opacity: 1;
    color: rgb(107 114 128 / var(--tw-text-opacity));
}
.text-gray-600 {
    --tw-text-opacity: 1;
    color: rgb(75 85 99 / var(--tw-text-opacity));
}
.text-gray-700 {
    --tw-text-opacity: 1;
    color: rgb(55 65 81 / var(--tw-text-opacity));
}
.text-gray-900 {
    --tw-text-opacity: 1;
    color: rgb(17 24 39 / var(--tw-text-opacity));
}
.text-indigo-500 {
    --tw-text-opacity: 1;
    color: rgb(99 102 241 / var(--tw-text-opacity));
}
.text-indigo-700 {
    --tw-text-opacity: 1;
    color: rgb(67 56 202 / var(--tw-text-opacity));
}
.text-red-500 {
    --tw-text-opacity: 1;
    color: rgb(239 68 68 / var(--tw-text-opacity));
}
.text-red-600 {
    --tw-text-opacity: 1;
    color: rgb(220 38 38 / var(--tw-text-opacity));
}
.text-typographyHeadingTextColor {
    color: var(--typography-heading-color);
}
.text-typographyLabelsTextColor {
    color: var(--typography-labels-color);
}
.text-typographySubHeadingTextColor {
    color: var(--typography-subHeading-color);
}
.text-vjwDanger {
    --tw-text-opacity: 1;
    color: hsl(from var(--color-danger) h s l / var(--tw-text-opacity));
}
.text-vjwPrimary {
    --tw-text-opacity: 1;
    color: hsl(from var(--color-primary) h s l / var(--tw-text-opacity));
}
.text-white {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity));
}
.\\!accent-vjwAccent {
    accent-color: hsl(from var(--color-accent) h s l / 1) !important;
}
.opacity-0 {
    opacity: 0;
}
.opacity-25 {
    opacity: 0.25;
}
.opacity-50 {
    opacity: 0.5;
}
.\\!shadow-none {
    --tw-shadow: 0 0 #0000 !important;
    --tw-shadow-colored: 0 0 #0000 !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow {
    --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-cardBoxShadow {
    --tw-shadow: var(--card-boxShadow);
    --tw-shadow-colored: var(--card-boxShadow);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-columnBoxShadow {
    --tw-shadow: var(--column-boxShadow);
    --tw-shadow-colored: var(--column-boxShadow);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
    --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
    --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
    --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.\\!outline-none {
    outline: 2px solid transparent !important;
    outline-offset: 2px !important;
}
.outline-none {
    outline: 2px solid transparent;
    outline-offset: 2px;
}
.outline {
    outline-style: solid;
}
.ring-1 {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2 {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-black {
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(0 0 0 / var(--tw-ring-opacity));
}
.ring-vjwDanger {
    --tw-ring-opacity: 1;
    --tw-ring-color: hsl(from var(--color-danger) h s l / var(--tw-ring-opacity));
}
.ring-vjwPrimary {
    --tw-ring-opacity: 1;
    --tw-ring-color: hsl(from var(--color-primary) h s l / var(--tw-ring-opacity));
}
.ring-opacity-5 {
    --tw-ring-opacity: 0.05;
}
.filter {
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.transition-all {
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.transition-colors {
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.transition-transform {
    transition-property: transform;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.duration-200 {
    transition-duration: 200ms;
}
.duration-300 {
    transition-duration: 300ms;
}
.duration-500 {
    transition-duration: 500ms;
}
.ease-in-out {
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

/* Custom Scrollbar Styles */

/* Hide scrollbar but allow scrolling */
.scrollbar-hide {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.scrollbar-hide::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}
/* Desktop view */
@media (min-width: 899px) {
  ::-webkit-scrollbar {
    width: 8px;
  }
}

/* Mobile view */
@media (max-width: 900px) {
  /* ::-webkit-scrollbar {
  } */
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: #acacac;
  border-radius: 10px;
  border: 2px solid transparent;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #acacac;
}

.horizontal-scroll-container {
  overflow-x: auto;
  scrollbar-width: thin;
  scroll-behavior: smooth;
  -ms-overflow-style: auto; /* IE and Edge */
  scrollbar-color: #acacac transparent; /* Firefox */
}

.scroll-container {
  overflow-y: auto;
  scrollbar-width: thin;
  -ms-overflow-style: auto; /* IE and Edge */
  scrollbar-color: #acacac transparent; /* Firefox */

  /* Custom scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #acacac;
    border-radius: 10px;
    border: 2px solid transparent;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #acacac;
  }
}

.hover\\:\\!border-vjwPrimary:hover {
    --tw-border-opacity: 1 !important;
    border-color: hsl(from var(--color-primary) h s l / var(--tw-border-opacity)) !important;
}

.hover\\:border-gray-400:hover {
    --tw-border-opacity: 1;
    border-color: rgb(156 163 175 / var(--tw-border-opacity));
}

.hover\\:border-b-vjwPrimary:hover {
    --tw-border-opacity: 1;
    border-bottom-color: hsl(from var(--color-primary) h s l / var(--tw-border-opacity));
}

.hover\\:bg-blue-700:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(29 78 216 / var(--tw-bg-opacity));
}

.hover\\:bg-gray-100:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}

.hover\\:bg-gray-200:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}

.hover\\:bg-gray-300:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}

.hover\\:bg-indigo-200:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(199 210 254 / var(--tw-bg-opacity));
}

.hover\\:bg-indigo-700:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(67 56 202 / var(--tw-bg-opacity));
}

.hover\\:bg-vjwDanger\\/30:hover {
    background-color: hsl(from var(--color-danger) h s l / 0.3);
}

.hover\\:bg-vjwPrimary:hover {
    --tw-bg-opacity: 1;
    background-color: hsl(from var(--color-primary) h s l / var(--tw-bg-opacity));
}

.hover\\:bg-vjwSecondary:hover {
    --tw-bg-opacity: 1;
    background-color: hsl(from var(--color-secondary) h s l / var(--tw-bg-opacity));
}

.hover\\:bg-vjwSecondary\\/5:hover {
    background-color: hsl(from var(--color-secondary) h s l / 0.05);
}

.hover\\:text-gray-800:hover {
    --tw-text-opacity: 1;
    color: rgb(31 41 55 / var(--tw-text-opacity));
}

.hover\\:text-vjwPrimary:hover {
    --tw-text-opacity: 1;
    color: hsl(from var(--color-primary) h s l / var(--tw-text-opacity));
}

.hover\\:text-vjwPrimary\\/80:hover {
    color: hsl(from var(--color-primary) h s l / 0.8);
}

.hover\\:underline:hover {
    text-decoration-line: underline;
}

.hover\\:ring-1:hover {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.hover\\:ring-vjwPrimary:hover {
    --tw-ring-opacity: 1;
    --tw-ring-color: hsl(from var(--color-primary) h s l / var(--tw-ring-opacity));
}

.focus\\:\\!border-2:focus {
    border-width: 2px !important;
}

.focus\\:\\!border-vjwDanger:focus {
    --tw-border-opacity: 1 !important;
    border-color: hsl(from var(--color-danger) h s l / var(--tw-border-opacity)) !important;
}

.focus\\:\\!border-vjwPrimary:focus {
    --tw-border-opacity: 1 !important;
    border-color: hsl(from var(--color-primary) h s l / var(--tw-border-opacity)) !important;
}

.focus\\:bg-vjwSecondary:focus {
    --tw-bg-opacity: 1;
    background-color: hsl(from var(--color-secondary) h s l / var(--tw-bg-opacity));
}

.focus\\:\\!outline-none:focus {
    outline: 2px solid transparent !important;
    outline-offset: 2px !important;
}

.focus\\:outline-none:focus {
    outline: 2px solid transparent;
    outline-offset: 2px;
}

.focus\\:ring:focus {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-1:focus {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-4:focus {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-gray-100:focus {
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(243 244 246 / var(--tw-ring-opacity));
}

.focus\\:ring-vjwPrimary:focus {
    --tw-ring-opacity: 1;
    --tw-ring-color: hsl(from var(--color-primary) h s l / var(--tw-ring-opacity));
}

.disabled\\:\\!cursor-not-allowed:disabled {
    cursor: not-allowed !important;
}

.disabled\\:cursor-not-allowed:disabled {
    cursor: not-allowed;
}

.disabled\\:\\!opacity-50:disabled {
    opacity: 0.5 !important;
}

.disabled\\:opacity-50:disabled {
    opacity: 0.5;
}

.group:hover .group-hover\\:block {
    display: block;
}

@media (min-width: 640px) {
    .sm\\:col-span-2 {
        grid-column: span 2 / span 2;
    }
    .sm\\:h-14 {
        height: 3.5rem;
    }
    .sm\\:w-14 {
        width: 3.5rem;
    }
    .sm\\:w-48 {
        width: 12rem;
    }
    .sm\\:grid-cols-1 {
        grid-template-columns: repeat(1, minmax(0, 1fr));
    }
    .sm\\:grid-cols-2 {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    .sm\\:grid-cols-3 {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    .sm\\:p-6 {
        padding: 1.5rem;
    }
    .sm\\:p-8 {
        padding: 2rem;
    }
    .sm\\:px-4 {
        padding-left: 1rem;
        padding-right: 1rem;
    }
    .sm\\:py-4 {
        padding-top: 1rem;
        padding-bottom: 1rem;
    }
    .sm\\:text-sm {
        font-size: 0.875rem;
        line-height: 1.25rem;
    }
}

@media (min-width: 768px) {
    .md\\:w-1\\/2 {
        width: 50%;
    }
    .md\\:grid-cols-2 {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    .md\\:flex-row {
        flex-direction: row;
    }
    .md\\:px-4 {
        padding-left: 1rem;
        padding-right: 1rem;
    }
    .md\\:py-2 {
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
    }
    .md\\:text-base {
        font-size: 1rem;
        line-height: 1.5rem;
    }
    .md\\:text-lg {
        font-size: 1.125rem;
        line-height: 1.75rem;
    }
}

@media (min-width: 1024px) {
    .lg\\:col-span-4 {
        grid-column: span 4 / span 4;
    }
    .lg\\:grid-cols-3 {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    .lg\\:grid-cols-6 {
        grid-template-columns: repeat(6, minmax(0, 1fr));
    }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":";EAAA,qBAAc;EAAd;;;IAAA,sBAAc;IAAd,SAAc;IAAd,UAAc;IAAd,eAAc,EAAd,kCAAc;IAAd,mBAAc,EAAd,mCAAc;EAAA;;EAAd,kCAAc;EAAd;IAAA,gBAAc;IAAd,8BAAc;IAAd,oBAAc;EAAA;;EAAd;IAAA,iBAAc;IAAd,uBAAc;IAAd,6BAAc;EAAA;;EAAd,oCAAc;EAAd;;IAAA,eAAc;IAAd,cAAc;EAAA;;EAAd,yCAAc;EAAd;;;;IAAA,aAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd,yBAAc;EAAA;;EAAd,uBAAc;EAAd;;IAAA,gBAAc;EAAA;;EAAd,qBAAc;EAAd;IAAA,wBAAc;IAAd,cAAc;EAAA;;EAAd,sCAAc;EAAd;;;IAAA,qBAAc,EAAd,wCAAc;EAAA;AAAd;IAAA,wBAAc;IAAd,wBAAc;IAAd,mBAAc;IAAd,mBAAc;IAAd,cAAc;IAAd,cAAc;IAAd,cAAc;IAAd,eAAc;IAAd,eAAc;IAAd,aAAc;IAAd,aAAc;IAAd,kBAAc;IAAd,sCAAc;IAAd,8BAAc;IAAd,6BAAc;IAAd,4BAAc;IAAd,eAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,kBAAc;IAAd,2BAAc;IAAd,4BAAc;IAAd,sCAAc;IAAd,kCAAc;IAAd,2BAAc;IAAd,sBAAc;IAAd,8BAAc;IAAd,YAAc;IAAd,kBAAc;IAAd,gBAAc;IAAd,iBAAc;IAAd,kBAAc;IAAd,cAAc;IAAd,gBAAc;IAAd,aAAc;IAAd,mBAAc;IAAd,qBAAc;IAAd,2BAAc;IAAd,yBAAc;IAAd,0BAAc;IAAd,2BAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,yBAAc;IAAd;AAAc;AAAd;IAAA,wBAAc;IAAd,wBAAc;IAAd,mBAAc;IAAd,mBAAc;IAAd,cAAc;IAAd,cAAc;IAAd,cAAc;IAAd,eAAc;IAAd,eAAc;IAAd,aAAc;IAAd,aAAc;IAAd,kBAAc;IAAd,sCAAc;IAAd,8BAAc;IAAd,6BAAc;IAAd,4BAAc;IAAd,eAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,kBAAc;IAAd,2BAAc;IAAd,4BAAc;IAAd,sCAAc;IAAd,kCAAc;IAAd,2BAAc;IAAd,sBAAc;IAAd,8BAAc;IAAd,YAAc;IAAd,kBAAc;IAAd,gBAAc;IAAd,iBAAc;IAAd,kBAAc;IAAd,cAAc;IAAd,gBAAc;IAAd,aAAc;IAAd,mBAAc;IAAd,qBAAc;IAAd,2BAAc;IAAd,yBAAc;IAAd,0BAAc;IAAd,2BAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,yBAAc;IAAd;AAAc;AACd;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;IAAoB;AAAA;AACpB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,QAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,WAAmB;IAAnB;AAAmB;AAAnB;IAAA,cAAmB;IAAnB;AAAmB;AAAnB;IAAA,aAAmB;IAAnB;AAAmB;AAAnB;IAAA,WAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,0BAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,0BAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,yBAAmB;IAAnB;AAAmB;AAAnB;IAAA,yBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA;IAAmB;IAAnB;QAAA;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,yBAAmB;YAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,sDAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,uDAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,+DAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,8DAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,4DAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,gBAAmB;IAAnB,uBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,gCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,mCAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,gBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,gBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,eAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB,yCAAmB;IAAnB;AAAmB;AAAnB;IAAA,0EAAmB;IAAnB,8FAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,0CAAmB;IAAnB;AAAmB;AAAnB;IAAA,oCAAmB;IAAnB,4CAAmB;IAAnB;AAAmB;AAAnB;IAAA,+EAAmB;IAAnB,mGAAmB;IAAnB;AAAmB;AAAnB;IAAA,6EAAmB;IAAnB,iGAAmB;IAAnB;AAAmB;AAAnB;IAAA,0CAAmB;IAAnB,uDAAmB;IAAnB;AAAmB;AAAnB;IAAA,gFAAmB;IAAnB,oGAAmB;IAAnB;AAAmB;AAAnB;IAAA,yCAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,2GAAmB;IAAnB,yGAAmB;IAAnB;AAAmB;AAAnB;IAAA,2GAAmB;IAAnB,yGAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,gKAAmB;IAAnB,wJAAmB;IAAnB,iLAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,wBAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,+FAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;;AAiEnB,4BAA4B;;AAE5B,uCAAuC;AACvC;EACE,wBAAwB,EAAE,gBAAgB;EAC1C,qBAAqB,EAAE,YAAY;AACrC;;AAEA;EACE,aAAa,EAAE,0BAA0B;AAC3C;AACA,iBAAiB;AACjB;EACE;IACE,UAAU;EACZ;AACF;;AAEA,gBAAgB;AAChB;EACE;KACG;AACL;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB,EAAE,gBAAgB;EAC1C,oCAAoC,EAAE,YAAY;AACpD;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB,EAAE,gBAAgB;EAC1C,oCAAoC,EAAE,YAAY;;EAElD,kDAAkD;EAClD;IACE,UAAU;EACZ;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAzIA;IAAA,iCA0IA;IA1IA;AA0IA;;AA1IA;IAAA,sBA0IA;IA1IA;AA0IA;;AA1IA;IAAA,sBA0IA;IA1IA;AA0IA;;AA1IA;IAAA,kBA0IA;IA1IA;AA0IA;;AA1IA;IAAA,kBA0IA;IA1IA;AA0IA;;AA1IA;IAAA,kBA0IA;IA1IA;AA0IA;;AA1IA;IAAA,kBA0IA;IA1IA;AA0IA;;AA1IA;IAAA,kBA0IA;IA1IA;AA0IA;;AA1IA;IAAA,kBA0IA;IA1IA;AA0IA;;AA1IA;IAAA;AA0IA;;AA1IA;IAAA,kBA0IA;IA1IA;AA0IA;;AA1IA;IAAA,kBA0IA;IA1IA;AA0IA;;AA1IA;IAAA;AA0IA;;AA1IA;IAAA,oBA0IA;IA1IA;AA0IA;;AA1IA;IAAA,oBA0IA;IA1IA;AA0IA;;AA1IA;IAAA;AA0IA;;AA1IA;IAAA;AA0IA;;AA1IA;IAAA,2GA0IA;IA1IA,yGA0IA;IA1IA;AA0IA;;AA1IA;IAAA,oBA0IA;IA1IA;AA0IA;;AA1IA;IAAA;AA0IA;;AA1IA;IAAA,iCA0IA;IA1IA;AA0IA;;AA1IA;IAAA,iCA0IA;IA1IA;AA0IA;;AA1IA;IAAA,kBA0IA;IA1IA;AA0IA;;AA1IA;IAAA,yCA0IA;IA1IA;AA0IA;;AA1IA;IAAA,8BA0IA;IA1IA;AA0IA;;AA1IA;IAAA,2GA0IA;IA1IA,yGA0IA;IA1IA;AA0IA;;AA1IA;IAAA,2GA0IA;IA1IA,yGA0IA;IA1IA;AA0IA;;AA1IA;IAAA,2GA0IA;IA1IA,yGA0IA;IA1IA;AA0IA;;AA1IA;IAAA,oBA0IA;IA1IA;AA0IA;;AA1IA;IAAA,oBA0IA;IA1IA;AA0IA;;AA1IA;IAAA;AA0IA;;AA1IA;IAAA;AA0IA;;AA1IA;IAAA;AA0IA;;AA1IA;IAAA;AA0IA;;AA1IA;IAAA;AA0IA;;AA1IA;IAAA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA,kBA0IA;QA1IA;IA0IA;IA1IA;QAAA,iBA0IA;QA1IA;IA0IA;IA1IA;QAAA,mBA0IA;QA1IA;IA0IA;AAAA;;AA1IA;IAAA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA,kBA0IA;QA1IA;IA0IA;IA1IA;QAAA,mBA0IA;QA1IA;IA0IA;IA1IA;QAAA,eA0IA;QA1IA;IA0IA;IA1IA;QAAA,mBA0IA;QA1IA;IA0IA;AAAA;;AA1IA;IAAA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;IA1IA;QAAA;IA0IA;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer base {\n  /* Box sizing reset */\n  *,\n  *::before,\n  *::after {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n    border-width: 0; /* Explicitly reset border width */\n    border-style: solid; /* Ensure consistent border style */\n  }\n\n  /* Basic document-level defaults */\n  html {\n    line-height: 1.5;\n    -webkit-text-size-adjust: 100%;\n    font-family: inherit;\n  }\n\n  body {\n    min-height: 100vh;\n    scroll-behavior: smooth;\n    text-rendering: optimizeSpeed;\n  }\n\n  /* Make images easier to work with */\n  img,\n  picture {\n    max-width: 100%;\n    display: block;\n  }\n\n  /* Inherit fonts for inputs and buttons */\n  input,\n  button,\n  textarea,\n  select {\n    font: inherit;\n    /* border: inherit;  */\n    border-color: inherit;\n    background-color: inherit;\n  }\n\n  /* Remove list styles */\n  ul,\n  ol {\n    list-style: none;\n  }\n\n  /* Anchor tag reset */\n  a {\n    text-decoration: inherit;\n    color: inherit;\n  }\n\n  /* Only lighten existing div borders */\n  div,\n  input,\n  textarea {\n    border-color: inherit; /* Prevent forcing borders on all divs */\n  }\n}\n\n/* Custom Scrollbar Styles */\n\n/* Hide scrollbar but allow scrolling */\n.scrollbar-hide {\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n}\n\n.scrollbar-hide::-webkit-scrollbar {\n  display: none; /* Chrome, Safari, Opera */\n}\n/* Desktop view */\n@media (min-width: 899px) {\n  ::-webkit-scrollbar {\n    width: 8px;\n  }\n}\n\n/* Mobile view */\n@media (max-width: 900px) {\n  /* ::-webkit-scrollbar {\n  } */\n}\n\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: #acacac;\n  border-radius: 10px;\n  border: 2px solid transparent;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background-color: #acacac;\n}\n\n.horizontal-scroll-container {\n  overflow-x: auto;\n  scrollbar-width: thin;\n  scroll-behavior: smooth;\n  -ms-overflow-style: auto; /* IE and Edge */\n  scrollbar-color: #acacac transparent; /* Firefox */\n}\n\n.scroll-container {\n  overflow-y: auto;\n  scrollbar-width: thin;\n  -ms-overflow-style: auto; /* IE and Edge */\n  scrollbar-color: #acacac transparent; /* Firefox */\n\n  /* Custom scrollbar for Chrome, Safari and Opera */\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: #acacac;\n    border-radius: 10px;\n    border: 2px solid transparent;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background-color: #acacac;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
